import React from 'react';

/**
 * Reusable date range controls for work / timesheet views.
 */
const WorkDataDateRangeFilter = ({
  startDate,
  endDate,
  onStartDateChange,
  onEndDateChange,
  onClear,
  labels = {},
  /** If set, controls visibility of the reset button; otherwise shown when either date is set. */
  showClearButton,
}) => {
  const startLabel = labels.start ?? 'Start date';
  const endLabel = labels.end ?? 'End date';
  const clearLabel = labels.clear ?? 'Clear range';
  const showClear =
    showClearButton !== undefined ? showClearButton : !!(startDate || endDate);

  return (
    <div
      className="work-data-date-range-filter"
      style={{
        display: 'flex',
        flexWrap: 'wrap',
        gap: '12px',
        alignItems: 'flex-end',
        marginBottom: '12px',
        marginTop: '4px',
      }}
    >
      <div>
        <label htmlFor="work-data-range-start" style={{ display: 'block', fontSize: '12px', marginBottom: '4px' }}>
          {startLabel}
        </label>
        <input
          id="work-data-range-start"
          type="date"
          className="form-control form-control-sm"
          style={{ minWidth: '160px' }}
          value={startDate}
          onChange={(e) => onStartDateChange(e.target.value)}
        />
      </div>
      <div>
        <label htmlFor="work-data-range-end" style={{ display: 'block', fontSize: '12px', marginBottom: '4px' }}>
          {endLabel}
        </label>
        <input
          id="work-data-range-end"
          type="date"
          className="form-control form-control-sm"
          style={{ minWidth: '160px' }}
          value={endDate}
          onChange={(e) => onEndDateChange(e.target.value)}
        />
      </div>
      {showClear && onClear && (
        <button type="button" className="btn btn-outline-secondary btn-sm" onClick={onClear}>
          {clearLabel}
        </button>
      )}
    </div>
  );
};

export default WorkDataDateRangeFilter;
